import { Cartesian3, Cartographic, createWorldTerrain, Ion, JulianDate, SampledPositionProperty, SampledProperty, sampleTerrain, sampleTerrainMostDetailed } from 'cesium';

Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4MGE1MzVlYy1kZjMxLTQxMWUtODM4MS03OGE1NjRlOWRlNTUiLCJpZCI6NzIzNTEsImlhdCI6MTYzNTk2MzQ3MH0.Opk0SYvfjQB8kYJl6eauLtXev4dvwf1sgnT0HrqATSA';

export const terrainProvider = createWorldTerrain();

export interface CustomGeopoint {
    _key:  string;
    _type: Type;
    alt:   number;
    lat:   number;
    lng:   number;
    time:  Date;
    cumul: number;
}

export enum Type {
    CustomGeopoint = 'customGeopoint',
}

const buildPositionProperty = (hikeData: Array<CustomGeopoint>): Promise<[Array<Cartesian3>, SampledPositionProperty, SampledProperty]> => {
    let cartographicPositions: Array<Cartographic> = [];
    let times: Array<JulianDate> = [];

    const sampledPositionProperty = new SampledPositionProperty();
    const sampledCumulProperty = new SampledProperty(Number);
  
    hikeData.forEach((point, i) => {
        const { lat, lng, time, cumul } = point;
  
        const newCartographicPosition = Cartographic.fromDegrees(lng, lat);
        const julianTime = JulianDate.fromIso8601(String(time));

        sampledCumulProperty.addSample(julianTime, cumul);
        cartographicPositions = [...cartographicPositions, newCartographicPosition];

        times = [...times, julianTime];
    });

    return sampleTerrainMostDetailed(terrainProvider, cartographicPositions).then(newPositions => {
        let newHikePoints: Array<Cartesian3> = [];

        hikeData.forEach((item, i) => {
            const { lat, lng } = item;

            let newCartesian3Pos = Cartesian3.fromDegrees(lng, lat, newPositions[i].height);
        
            newHikePoints = [...newHikePoints, newCartesian3Pos];

            sampledPositionProperty.addSample(times[i], newCartesian3Pos);
        });
        
        return [newHikePoints, sampledPositionProperty, sampledCumulProperty];
    });
};

export default buildPositionProperty;